import { useState } from 'react';
import { queryClient } from 'queries/queryClient';

const mutationCache = queryClient.getMutationCache();

const useToggleSavedForLater = () => {
    const [savedForLater, setSavedForLater] = useState(false);

    const toggleSavedForLater = () => {
        // IMPORTANT: we clear the mutation cache because of the "saved for later" button's success states.
        // After a mutation (saved or unsaved) that button success state needs to remain showing as the row exits.
        // If we don't clear the cache, and the user saves and unsaves the same item multiple times, the button
        // will get stuck in a success state until page refresh (or something else kills the mutation cache naturally)
        mutationCache.clear();

        setSavedForLater(!savedForLater);
    };

    return { savedForLater, toggleSavedForLater };
};

export { useToggleSavedForLater };
